import { store, remoteSupportMeetingSlice } from '@ventionco/remote-support-components';

interface RemoteSupportServices {
  isActive: () => boolean
  isInWaitingRoom: () => boolean
  isInCall: () => boolean
  updateEstopState: (pEstopState: any) => void
}

export const remoteSupportServices: RemoteSupportServices = {
  isActive: () => {
    try {
      const remoteSupportMeetingReducer = store.getState().remoteSupportMeetingReducer;
      return remoteSupportMeetingReducer.isRemoteSupportConnected || remoteSupportMeetingReducer.isInWaitingRoom;
    }
    catch (e) {
      console.error('remoteSupportServices.isActive: ', e);
      return false;
    }
  },
  isInWaitingRoom: () => {
    try {
      return store.getState().remoteSupportMeetingReducer.isInWaitingRoom;
    }
    catch (e) {
      console.error('remoteSupportServices.isUserInWaitingRoom: ', e);
      return false;
    }
  },
  isInCall: () => {
    try {
      return store.getState().remoteSupportMeetingReducer.isRemoteSupportConnected;
    }
    catch (e) {
      console.error('remoteSupportServices.isUserInCall: ', e);
      return false;
    }
  },
  updateEstopState: (pEstopState: any) => {
    try {
      store.dispatch(remoteSupportMeetingSlice.actions.setEStopStatus(pEstopState));
    }
    catch (e) {
      console.error('remoteSupportServices.updateEstopState: ', e);
    }
  },
};
